import { render } from "./reasons-2.vue?vue&type=template&id=e00c5caa&scoped=true"
import script from "./reasons-2.vue?vue&type=script&lang=js"
export * from "./reasons-2.vue?vue&type=script&lang=js"

import "./reasons.scss?vue&type=style&index=0&id=e00c5caa&scoped=true&lang=scss"

import exportComponent from "/home/rof/src/bitbucket.org/AsokoInsight/virtual-dealroom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e00c5caa"]])

export default __exports__